import React from "react";
import styles from "./MainPageProduct.module.scss";
import classNames from "classnames/bind";
import { IonIcon } from "@ionic/react";
import { heart, heartOutline } from "ionicons/icons";
import { Product } from "@core/types";
import { useWishListData } from "../../../../../providers/wishListStore";

interface WishlistButtonProps {
  productId: Product["id"];
}

const cx = classNames.bind(styles);

const WishlistButton = ({ productId }: WishlistButtonProps) => {
  const { toggleWish, isWishProduct } = useWishListData();

  return (
    <div className={cx("productsSpecialLeft__heart", "productCommon__heart")}>
      <div
        onClick={(e) => {
          toggleWish(productId);
          e.stopPropagation();
        }}
      >
        <IonIcon
          className={cx("productHeartIcon")}
          color="primary"
          icon={isWishProduct(productId) ? heart : heartOutline}
        />
      </div>
    </div>
  );
};

export default WishlistButton;
